<template>
  <div class="chart-skeleton" style="height: 450px" id="chart-skeleton-loading">
    <div class="chart-header-skeleton">
      <div
        class="content-skeleton animation-skeleton"
        style="height: 30px!important;"
      ></div>
      <div
        class="content-skeleton animation-skeleton"
        style="height: 30px !important; width: 5% !important;; margin-left: 10px"
      ></div>
    </div>

    <div class="chart-message-skeleton" v-for="loader in loaders" :key="loader">
      <div
        class="image-skeleton me-2 animation-skeleton"
        style="border-radius: 50%; width: 40px !important;; height: 40px !important;"
      ></div>
      <div
        class="content-skeleton animation-skeleton"
        style="height: 30px !important;"
      ></div>
    </div>
    <div class="chart-footer-skeleton">
      <div
        class="content-skeleton animation-skeleton"
        style="height: 45px !important;; width: 80% !important;"
      ></div>
      <div
        class="content-skeleton animation-skeleton"
        style="height: 45px !important; width: 12% !important; margin-left: 10px"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'stream-chart-skeleton',
  data(){
    return{
        loaders: [1,2,3,4]
    }
  }
};
</script>

<style scoped>
.chart-header-skeleton {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #2A2A20;
}
.chart-footer-skeleton {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #2A2A20;
}
.chart-message-skeleton {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}

.chart-skeleton {
  background: var(--color-secondary);
  border-radius: 10px;
  position: relative;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  border: 1px solid var(--color-light);
  margin-bottom:10px;
}

.image-skeleton {
  width: 28%;
  height: 100px;
  background: #B6BBC4;
  border-radius: 10px;
}
.content-skeleton {
  width: 100%;
  background: #B6BBC4;
  border-radius: 4px;
  margin-top: 10px;
}
</style>
